import React, {useEffect} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import SurveyPage from './pages/SurveyPage';
import IntroPage from "./pages/IntroPage";
import AgreePage from "./pages/AgreePage";
import ResultPage from "./pages/ResultPage";
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import PublicRoute from "./components/PublicRoute";
import PrivateRoute from "./components/PrivateRoute";
import PasswordChangeForm from "./components/auth/PasswordChangeForm";
import QuestionBoardPage from "./pages/QuestionBoardPage";
import ReportPage from "./pages/ReportPage";
import ThanksPage from "./pages/ThanksPage";
import ErrorPage from "./pages/ErrorPage";
import {RecoilRoot, useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {findFilesByFileGcd} from "./lib/api/file";
import {
    answerState,
    bizFileState,
    etcFileState, etcReturnFileState, familyState,
    intFileState,
    rentFileState, rentState,
    simpleFileState,
    userState
} from "./state/globalState";
import {findTmpContByAdmnNo} from "./lib/api/survey";
import client from "./lib/api/client";
import ResultMailPage from "./pages/ResultMailPage";

const App = () => {
    const [userInfo, setUserInfo] = useRecoilState(userState);
    const setIntFiles = useSetRecoilState(intFileState);
    const setBizFiles = useSetRecoilState(bizFileState);
    const setRentFiles = useSetRecoilState(rentFileState);
    const setEtcFiles = useSetRecoilState(etcFileState);
    const setSimpleFiles = useSetRecoilState(simpleFileState);
    const setEtcReturnFiles = useSetRecoilState(etcReturnFileState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setRent = useSetRecoilState(rentState);
    const setFamily = useSetRecoilState(familyState);

    async function getExternalIp() {
        const ipData = await fetch('https://geolocation-db.com/json/');
        const locationIp = await ipData.json();
        return locationIp.IPv4;
    }

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        // console.log(data);
        return data;
    }

    const getTmpCont = async (admnNo) => {
        const { data } = await findTmpContByAdmnNo(admnNo);
        return data;
    }
    const getPasInfo = async (admnNo, corprInfoDiviNo, stdYear) => {
        const { data } = await client.get('/kognr/corprPasInfo', {
            params: {
                admnNo,
                corprInfoDiviNo,
                stdYear
            }
        });
        return data;
    }

    useEffect(() => {
        getExternalIp();
        // dispatch(setExternalIp(ip));
        // // 전역적으로 unhandled rejection을 처리
        // window.addEventListener('unhandledrejection', event => {
        //     console.error('Unhandled Promise Rejection:', event.reason);
        // });
    }, []);

    useEffect(() => {
        if (userInfo.admnNo && userInfo.stdYear) {
            getFiles(userInfo.admnNo, userInfo.stdYear).then((res) => {
                if (res.payload.length > 0) {
                    // 이자/배장소득 첨부파일
                    const intFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050001"));
                    const bizFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050002"));
                    const etcFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050003"));
                    const rentFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050004"));
                    const simpleFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050005"));
                    const etcReturnFilterFiles = res.payload.filter((file) => (file.kognrFileGcd === "HC050006"));
                    setIntFiles(intFilterFiles);
                    setBizFiles(bizFilterFiles);
                    setEtcFiles(etcFilterFiles);
                    setRentFiles(rentFilterFiles);
                    setSimpleFiles(simpleFilterFiles);
                    setEtcReturnFiles(etcReturnFilterFiles);
                }
            });

            // 질문지 대상자의 임시저장 컨텐츠가 존재하면 전역상태에 셋팅한다
            if (userInfo.surveyYn === "0" && userInfo.kognrTmpCont !== "") {
                const tmpCont = JSON.parse(userInfo.kognrTmpCont);
                const { answer, rent, family } = tmpCont;
                setAnswer(answer);
                setRent(rent);
                setFamily(family);
            }

            getPasInfo(userInfo.admnNo, userInfo.corprInfoDiviNo, userInfo.stdYear).then((res) => {
                const { success, payload } = res;
                if (success) {
                    setUserInfo({
                        ...userInfo,
                        corprName: payload.corprName,
                        koSendMail: payload.koSendMail,
                        koFileAttchYn: payload.koFileAttchYn,
                        teqOpenYn: payload.teqOpenYn,
                        citOpenYn: payload.citOpenYn
                    });
                }
            });
        }
    }, [userInfo.surveyYn]);


    return (
        <>
            <ReactNotification />
            <Router>
                <Switch>
                    <PublicRoute restricted={false} component={IntroPage} path="/" exact />
                    <PrivateRoute component={PasswordChangeForm} path="/passwordChange" exact />
                    <PrivateRoute component={AgreePage} path="/agree" exact />
                    <PrivateRoute component={SurveyPage} path="/survey" exact />
                    <PrivateRoute component={ResultPage} path="/result" exact />
                    <PrivateRoute component={ResultMailPage} path="/result-mail" exact />
                    <PrivateRoute component={QuestionBoardPage} path="/questions" exact />
                    <PrivateRoute component={QuestionBoardPage} path="/question/:brdNo" exact />
                    <PrivateRoute component={ReportPage} path="/report" exact />
                    <Route component={ThanksPage} path="/thanks" exact />
                    <Route path={"*"} component={ErrorPage}/>
                    {/*<PublicRoute restricted={false} component={ErrorPage} path="/error" exact/>*/}
                </Switch>
            </Router>
        </>
    );
};

export default App;
